import React from 'react';
import { Reveal } from '@/components/Reveal';

export const SectionHeading = ({ eyebrow, title, subtitle, center = false, className = '', as: Tag = 'h2' }) => (
  <div className={`mx-auto max-w-6xl ${className}`}>
    <Reveal className={`${center ? 'mx-auto text-center' : 'mx-auto text-center sm:mx-0 sm:text-left'} max-w-2xl`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <Tag className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
        {title}
      </Tag>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-white/60">{subtitle}</p>}
    </Reveal>
  </div>
);
